import React, { useEffect, useState } from 'react';
import ReactApexChart from "react-apexcharts";

const BarChartWithMarker = ({ width, height, data }) => {
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      const parsedData = JSON.parse(JSON.stringify(data)); // deep clone

      if (!parsedData.series || !Array.isArray(parsedData.series)) {
        throw new Error("Invalid chart data: 'series' is missing or not an array.");
      }

      setSeries(parsedData.series);

      // Default + incoming options
      setOptions({
        chart: {
          type: 'bar',
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          formatter: function (val, opt) {
            const goals = opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]?.goals;
            return goals && goals.length ? `${val} / ${goals[0].value}` : val;
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Actual", "Expected"],
          markers: {
            fillColors: ["#00E396", "#775DD0"],
          },
        },
        ...parsedData.options // if your data has custom overrides
      });

      setError(null);
    } catch (err) {
      console.error("Chart render error:", err);
      setError("Error rendering bar chart. Please check the data format.");
    }
  }, [data]);

  return (
    <div style={{ width, height }}>
      {error ? (
        <div style={{ color: 'red', padding: '10px' }}>{error + "Use Another favorite prompt to generate"}</div>
      ) : (
        <ReactApexChart
          dir="ltr"
          className="apex-charts"
            options={data}
          series={series}
          type="bar"
          height={height}
          width={width}
        />
      )}
    </div>
  );
};

export default BarChartWithMarker;
